import React, { useState, useRef } from "react";

// components
import CardTaskTable from "components/Cards/CardTaskTable.js";
import CardTaskForm from "components/Cards/CardTaskForm.js";
import CardSecretary from "components/Cards/CardSecretary.js";

export default function Tables() {
  const [selectedTask, setSelectedTask] = useState(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isSecretaryOpen, setIsSecretaryOpen] = useState(false);
  const taskTableRef = useRef();

  const handleEditTask = (task) => {
    setSelectedTask(task);
    setIsFormOpen(true);
  };

  const handleNewTask = () => {
    setSelectedTask(null);
    setIsFormOpen(true);
  };

  const handleFormSave = (result) => {
    setIsFormOpen(false);
    setSelectedTask(null);

    // Ensure tasks are reloaded with current filters preserved
    // Use setTimeout to ensure the modal close state is set before reload
    setTimeout(() => {
      if (taskTableRef.current) {
        taskTableRef.current.reloadTasks();
      }
    }, 10);
  };

  const handleFormCancel = () => {
    setIsFormOpen(false);
    setSelectedTask(null);
  };

  const handleTaskDeleted = (taskId) => {
    // The CardTaskTable handles reloading after deletion with filters preserved
    // This callback is primarily for any additional UI updates
  };

  const handleSecretaryOpen = () => {
    setIsSecretaryOpen(true);
  };

  const handleSecretaryClose = () => {
    setIsSecretaryOpen(false);
  };

  const handleSecretaryTaskCreated = (task) => {
    setIsSecretaryOpen(false);

    // Reload task list to show the new task
    setTimeout(() => {
      if (taskTableRef.current) {
        taskTableRef.current.reloadTasks();
      }
    }, 10);
  };

  return (
    <>
      <div className="flex flex-wrap mt-4">
        {/* Main Task Table */}
        <div className="w-full mb-12 px-4">
          <CardTaskTable
            ref={taskTableRef}
            onEditTask={handleEditTask}
            onDeleteTask={handleTaskDeleted}
            onNewTask={handleNewTask}
            onSecretary={handleSecretaryOpen}
          />
        </div>
      </div>

      {/* Task Form Modal */}
      <CardTaskForm
        task={selectedTask}
        isOpen={isFormOpen}
        onSave={handleFormSave}
        onCancel={handleFormCancel}
      />

      {/* Secretary Modal */}
      <CardSecretary
        isOpen={isSecretaryOpen}
        onClose={handleSecretaryClose}
        onTaskCreated={handleSecretaryTaskCreated}
      />
    </>
  );
}
